<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Spinner from "../components/spinner.svelte";
    import UnmatchedUsers from "./components/unmatchedusers.svelte";
    import LogDetails from "../components/logdetails.svelte";
    import UserError from "./components/usererror.svelte";

    let errors;
    let isPageLoading = true;
    let usersList = [];

    onMount(async () => {   
            await getUnmatchedStaff();
        await getErrorsList();
        isPageLoading = false;
    });

    const getUnmatchedStaff = async () => {
        let resp = await wrappedFetch("/api/reports/GetUnmatchedStaff", {
            method: "post",
        });
        let unmatchedStaff = await resp.json();
        // if (unmatchedStaff.length > 0)
        // unmatchedStaff.forEach((p) => p.role = "Staff");
        usersList = unmatchedStaff;
    };

    const getErrorsList = async () => {
        let resp = await wrappedFetch(
            `/api/reports/GetImportErrorsList?userType=Staff`,
            { method: "post" }
        );
        errors = await resp.json();
    };

    const matchStaff = async (user, bid) => {
        let resp = await wrappedFetch(
            `/api/account/StaffMatch?bid=${bid}&pid=${user.personId}&dfes=${user.dfes}`,
            { method: "post" }
        );
        let response = await resp.json();
        if (response.success) getUnmatchedStaff();
        return response;
    };

    const createUser = async (bid) => {
        let resp = await wrappedFetch(
            `/api/account/CreateNewStaff?bsid=${bid}`,
            { method: "post" }
        );
        let response = await resp.json();
        if (response.success) getUnmatchedStaff();
        return response;
    };

    const onRequestAddTransfer = async (
        matchedUser,
        type,
        selectedUser,
        bid
    ) => {
        let data = { matchedStaff: matchedUser, selectedStaff: selectedUser };
        let resp = await wrappedFetch(
            `/api/account/StaffRequestAddTransfer?bid=${bid}&type=${type}`,
            {
                method: "post",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        let result = await resp.json();
        if (result.success) getUnmatchedStaff();
        return result;
    };

    const cancelPendingTransferRequest = async (user) => {
        let resp = await wrappedFetch(
            `/api/reports/CancelPendingTransferRequest`,
            {
                method: "post",
                body: JSON.stringify(user),
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        let result = await resp.json();
        if (result.success) getUnmatchedStaff();
        return result;
    };
</script>

<svelte:head>
    <title>Import Logs | Staff Logs | Wavenet Nimbus </title>
</svelte:head>

{#if isPageLoading}
    <Spinner />
{:else}
    <LogDetails backURL="/app/import/logs">
        <div slot="title"><h1>Staff Logs</h1>
            <p>If an account already exists with the same or similar details, manual matching is required. To do this simply select "match options" next to the user's name and then choose the appropriate option.</p>
        </div>
        <div slot="tab1Header">Matches</div>
        <div slot="tab2Header">Errors</div>
        <div slot="tab1Content">
            <UnmatchedUsers
                bind:unmatchedUsers={usersList}
                selectedRoleType="S"
                onMatch={(user, bid) => matchStaff(user, bid)}
                onCreate={(bid) => createUser(bid)}
                onAddTransfer={(matchedUser, type, bid, selecteduser) => onRequestAddTransfer(matchedUser, type, selecteduser, bid)}
                onCancelPendingTransferRequest={(user) => cancelPendingTransferRequest(user)} />
        </div>
        <div slot="tab2Content">
            <UserError userType="Staff" bind:errors />
        </div>
    </LogDetails>
{/if}
